export default __webpack_public_path__ + "static/media/step2real_logo_black.71237876.svg";